import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Backdrop,
  Button,
  Card,
  CircularProgress,
  Grid,
  IconButton
} from '@material-ui/core';
import axios from 'src/utils/axios';
import { makeStyles } from '@material-ui/styles';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import GenericReportTable from '../../components/GenericReportTable';
import GenericDatePicker from '../../components/GenericDatePicker';

const useStyles = makeStyles(theme => ({
  root: {},
  review: {
    marginTop: theme.spacing(2)
  },
  gridDatePicker: {
    padding: '20px'
  }
}));

function Productivity({ className, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('Dashboard');
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [bitisTarihi, setBitisTarihi] = React.useState(today);
  const [reportData, setReportData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const getData = () => {
    setLoading(true);
    axios
      .get(`/GetDashboardProductivity/${baslangicTarihi}/${bitisTarihi}`)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setReportData([]);
        } else {
          setReportData(ResponseData);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };
  const dataListCells = [
    {
      id: 'TechCode',
      numeric: false,
      disablePadding: true,
      label: t('txtTechCode')
    },
    { id: 'Name', numeric: false, disablePadding: true, label: t('txtName') },
    { id: 'SName', numeric: false, disablePadding: true, label: t('txtSName') },
    { id: 'Rate', numeric: true, disablePadding: true, label: t('txtRate') },
    {
      id: 'FinishedWork',
      numeric: true,
      disablePadding: true,
      label: t('txtFinishedWork')
    },
    {
      id: 'TotalWork',
      numeric: true,
      disablePadding: true,
      label: t('txtTotalWork')
    }
  ];
  return (
    <Card className={clsx(classes.root, className)}>
      <div {...rest} className={clsx(classes.root, className)}>
        <Grid container spacing={1} className={classes.gridDatePicker}>
          <Grid item xs={6} sm={5}>
            <GenericDatePicker
              datePickerLabel={t('lblStartDate')}
              selectedDate={baslangicTarihi}
              handleDateChange={value => setBaslangicTarihi(value)}
            />
          </Grid>
          <Grid item xs={6} sm={5}>
            <GenericDatePicker
              datePickerLabel={t('lblEndDate')}
              selectedDate={bitisTarihi}
              handleDateChange={value => setBitisTarihi(value)}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => getData()}
              endIcon={<SearchIcon />}
            >
              {t('lblSearch')}
            </Button>
          </Grid>
        </Grid>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        {reportData.length > 0 && (
          <Grid container spacing={1}>
            <GenericReportTable
              reportTitle={t('lblProductivity')}
              reportHeader={dataListCells}
              reportData={reportData}
            />
          </Grid>
        )}
      </div>
    </Card>
  );
}

Productivity.propTypes = {
  className: PropTypes.string
};

export default Productivity;
